(() => {
  // Both apps load asynchronously. Move the original banner to preserve app handlers.
  if (/\/products\/enchanted-butterfly-ball-gown\/?$/.test(window.location.pathname)) {
    let pending = false;
    const placeGift = () => {
      pending = false;
      const timeline = document.querySelector('.xbEdd');
      const gift = document.getElementById('ahlGiftBnr10513418_866833');
      if (timeline && gift && timeline.nextElementSibling !== gift) {
        timeline.after(gift);
      }
      document.querySelectorAll('.product-form-buttons.fr-gift-form').forEach((form) => {
        if (!form.querySelector('.ahlGiftBnrHld')) form.classList.remove('fr-gift-form');
      });
    };
    const observer = new MutationObserver((records) => {
      if (pending || !records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1))) return;
      pending = true;
      requestAnimationFrame(placeGift);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    placeGift();
  }
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const targets = {
    proof: () => document.querySelector('[data-feb-proof]'),
    reviews: () => document.querySelector('#AirReviews-BlockWrapper'),
    fit: () => document.querySelector('.loving-size-recommender-section'),
    purchase: () => document.querySelector('variant-picker[data-template-product-match="true"]')
      || document.querySelector('[id^="ProductInformation-"]'),
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-feb-scroll-to]');
    if (!trigger) return;

    const resolver = targets[trigger.dataset.febScrollTo];
    const target = resolver ? resolver() : null;
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start',
    });

    if (trigger.dataset.febScrollTo === 'purchase') {
      window.setTimeout(() => {
        const selectedVariant = target.querySelector('input[type="radio"]:checked, select[name^="options"]');
        if (selectedVariant) selectedVariant.focus({ preventScroll: true });
      }, prefersReducedMotion ? 0 : 450);
    }
  });
})();
